// extracted by mini-css-extract-plugin
export default {"nav":"Sidebar_nav__UPi4i","social":"Sidebar_social__0NECg","logo":"Sidebar_logo__hKUaf"};